import { useCallback } from 'react';
import { MOVE, moveProductGroup } from './move-productgroup-slots';
import { useSaveLibraryManagedProductGroupsOrder } from '../api/useSaveLibraryManagedProductGroupsOrder';
import { MappedProductGroup } from '../../../../store/api';

export const useReorderProductGroups = (productGroups: MappedProductGroup[]) => {
    const { mutate: saveProductGroupOrder, isLoading: isSavingOrderLoading } =
        useSaveLibraryManagedProductGroupsOrder();

    const moveAndSaveProductGroup = useCallback(
        (slotId, direction) => {
            const nextProductGroupsUpdatedSlots = moveProductGroup(productGroups, slotId, direction);
            const reducedProductGroupList = nextProductGroupsUpdatedSlots.map((slot, index) => ({
                slotId: slot.id,
                slotIndex: index
            }));

            saveProductGroupOrder(reducedProductGroupList);
        },
        [productGroups, saveProductGroupOrder]
    );

    const moveDown = useCallback(
        slotId => {
            const LAST_SLOT_INDEX = productGroups.length - 1;
            if (slotId === LAST_SLOT_INDEX) return;
            moveAndSaveProductGroup(slotId, MOVE.down);
        },
        [productGroups, moveAndSaveProductGroup]
    );

    const moveUp = useCallback(
        slotId => {
            const FIRST_SLOT_INDEX = 0;
            if (slotId === FIRST_SLOT_INDEX) return;
            moveAndSaveProductGroup(slotId, MOVE.up);
        },
        [moveAndSaveProductGroup]
    );

    return {
        isSavingOrderLoading,
        moveAndSaveProductGroup,
        moveDown,
        moveUp
    };
};
